import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router'

import { Button } from '../components/ui/button'
import { Input } from '../components/ui/input'
import { api, ErrorApi } from '../lib/api'
import { LONGITUD_MINIMA_PASSWORD, passwordValida } from '../lib/password-policy'

export function ResetPassword() {
    const [params] = useSearchParams()
    const token = params.get('token') ?? ''
    const navigate = useNavigate()
    const [password, setPassword] = useState('')
    const [error, setError] = useState<string | null>(null)
    const [enviando, setEnviando] = useState(false)

    async function enviar(e: React.FormEvent) {
        e.preventDefault()
        setError(null)
        if (!passwordValida(password)) {
            setError(`Mínimo ${LONGITUD_MINIMA_PASSWORD} caracteres`)
            return
        }
        setEnviando(true)
        try {
            await api.post('/auth/reset', { token, password })
            navigate('/login', { replace: true })
        } catch (err) {
            setError(err instanceof ErrorApi ? err.message : 'Enlace inválido o caducado')
        } finally {
            setEnviando(false)
        }
    }

    return (
        <div className="grid min-h-screen place-items-center bg-neutral-950 font-mono text-neutral-200">
            <form onSubmit={(e) => void enviar(e)} className="mx-4 w-full max-w-80 space-y-4 rounded-lg border border-neutral-800 p-6">
                <h1 className="text-sm font-semibold text-neutral-100">Nueva contraseña</h1>
                <Input
                    aria-label="Nueva contraseña"
                    type="password"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                {error && (
                    <p role="alert" className="text-xs text-red-400">
                        {error}
                    </p>
                )}
                <Button type="submit" className="min-h-11 w-full" disabled={enviando || !password}>
                    Guardar
                </Button>
                <Link to="/login" className="block text-center text-xs text-neutral-500">
                    Login
                </Link>
            </form>
        </div>
    )
}
